import React, { useState, useRef } from "react";
import { Headphones, FileText, ShieldHalf, RotateCcw, Phone, Mail } from "lucide-react";
import { FaWhatsapp, FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import "./Support.css";

const tabs = [
  ["help", "Help Center", "MTN SUPPORT CONTACT", Headphones],
  ["terms", "Terms & Conditions", "TERMS & CONDITIONS", FileText],
  ["privacy", "Privacy Policy", "PRIVACY POLICY", ShieldHalf],
  ["subscription", "Subscription Policy", "SUBSCRIPTION & REFUND POLICY", RotateCcw],
];
const policies = {
  terms: [
    ["Eligibility", "Ghana Gameium is available to users who are legally eligible to subscribe and use the service under applicable laws. By using the platform, you confirm that you meet the applicable eligibility requirements."],
    ["Subscription Service", "Ghana Gameium is a subscription-based gaming and entertainment platform.", ["Daily Pack: GHS 1 for 1 day.", "Weekly Pack: GHS 6 for 7 days.", "Monthly Pass: GHS 18 for 30 days.", "Charges are processed through your mobile operator. Check your selected plan and operator confirmation for renewal details."]],
    ["User Responsibilities", "Keep your mobile number and account information accurate and up to date. You are responsible for your account activity and for using games and platform features responsibly."],
    ["Privacy & Data Protection", "Your mobile number and related account information are used to provide and manage the service.", ["Service delivery", "Subscription management", "Customer support", "Service improvement"]],
    ["Service Availability", "We aim to provide reliable access to Ghana Gameium. Access may be interrupted by maintenance, network issues, technical faults, or circumstances beyond our control."],
    ["Responsible Use", "Do not misuse the platform, interfere with other users, attempt unauthorized access, or use automated tools to disrupt games or platform services."],
    ["Updates to the Service", "Games, features, and subscription options may change. Review the information shown on the website and during subscription for current service details."],
    ["Contact Support", "For account, subscription, billing, or service-related questions, use the official MTN customer care channels in the Help Center."],
  ],
  privacy: [
    ["Data Collection", "Ghana Gameium uses your mobile number, account information, and platform activity to deliver games and entertainment, manage subscriptions, maintain your session, and provide customer support."],
    ["Security & Protection", "Keep your login and verification details private. Never share a one-time password with anyone. For concerns about account access, contact customer care through the official support channels."],
    ["Gaming Activity & Service Performance", "Game and session information helps support platform features, troubleshoot technical issues, improve service performance, and identify misuse."],
    ["User Controls", "For questions about your account information or requests to access, update, or remove information, contact customer care through the channels listed in the Help Center."],
  ],
  subscription: [
    ["Subscription Plans", "Ghana Gameium offers a Daily Pack at GHS 1 for 1 day, a Weekly Pack at GHS 6 for 7 days, and a Monthly Pass at GHS 18 for 30 days. Choose your preferred plan on the Sign In page."],
    ["Activation & Access", "Subscription access becomes available after successful mobile operator confirmation. Sign in with your subscribed mobile number to access games and entertainment."],
    ["Cancellations & Renewals", "Subscribed users can select Unsubscribe from the website's account menu. The current cancellation flow removes subscription access immediately. Check your operator confirmation for the renewal terms of your selected plan."],
    ["Billing Support & Refund Inquiries", "For operator charges, billing questions, or refund requests, contact MTN Customer Care by dialing 100 or emailing customercare.GH@mtn.com. Refund requests are subject to review by the relevant billing provider."],
  ],
};
const contacts = [
  ["Dial", "100", "Toll Free", "tel:100", Phone],
  ["WhatsApp", "0554300000", "Chat Now", "https://wa.me/233554300000", FaWhatsapp],
  ["Email", "customercare.GH@mtn.com", "Send Email", "mailto:customercare.GH@mtn.com", Mail],
  ["Facebook", "MTNGhana", "Visit Page", "https://www.facebook.com/MTNGhana", FaFacebookF],
];
function Support() {
  const [activeTab, setActiveTab] = useState("help");
  const contentRef = useRef(null);
  const active = tabs.find(([id]) => id === activeTab);
  const HeaderIcon = active[3];
  const selectTab = (id) => {
    setActiveTab(id);
    if (contentRef.current) contentRef.current.scrollTop = 0;
  };
  const handleTabKey = (event, index) => {
    let next;
    if (event.key === "ArrowRight") next = (index + 1) % tabs.length;
    if (event.key === "ArrowLeft") next = (index + tabs.length - 1) % tabs.length;
    if (event.key === "Home") next = 0;
    if (event.key === "End") next = tabs.length - 1;
    if (next === undefined) return;
    event.preventDefault();
    selectTab(tabs[next][0]);
    event.currentTarget.parentElement.children[next].focus();
  };
  return (
    <div className="bg-black min-h-screen overflow-x-hidden pb-16">
<section
  className="relative h-[180px] sm:h-[220px] md:h-[310px] w-full bg-cover bg-center"
  style={{ backgroundImage: "url('/assets/banner-about-bg.webp')" }}
>
      {/* 🔴 RED COLOR OVERLAY */}
  <div className="absolute inset-0 bg-gradient-to-r from-[#ff003c]/40 to-[#6a00ff]/40 mix-blend-overlay"></div>

  <div className="relative z-30 h-full flex items-center">
    <div className="max-w-[1400px] mx-auto w-full px-4 sm:px-6 lg:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-6">

        {/* LEFT CONTENT */}
        <div className="text-white text-center md:text-left">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mt-6 md:mt-10">
            Support
          </h2>

          <div className="flex justify-center md:justify-start gap-2 text-sm text-gray-300 mt-2">
            <span>Home</span>
              <span>›</span>
              <span>Pages</span>
              <span>›</span>
              <span className="text-[#ff003c] font-semibold">Support</span>
          </div>
        </div>

{/* RIGHT IMAGES */}
<div className="relative hidden md:flex justify-end">

  {/* <img
    src="/assets/gamescard/support.png"
    alt="support"
    className="
      w-[420px] md:w-[520px] lg:w-[620px] 
      drop-shadow-2xl translate-y-[28px]
    "
  /> */}

</div>



      </div>
    </div>
  </div>
</section>
      <section className="gameium-support-section">
        <div className="gameium-support">
          <header className="support-heading">
            <span className="support-heading-icon"><HeaderIcon size={27} aria-hidden="true" /></span>
            <div><h2>{active[2]}</h2><p>{activeTab === "help" ? "Ghana Gameium • Customer Assistance" : "Ghana Gameium • Service Information"}</p></div>
          </header>
          <div className="support-tabs" role="tablist" aria-label="Support information">
            {tabs.map(([id, label, title, Icon], index) => <button key={id} id={"support-tab-" + id} type="button" role="tab" aria-selected={activeTab === id} aria-controls={"support-panel-" + id} tabIndex={activeTab === id ? 0 : -1} onClick={() => selectTab(id)} onKeyDown={(event) => handleTabKey(event, index)} className={activeTab === id ? "is-active" : ""}><Icon size={18} aria-hidden="true" />{label}</button>)}
          </div>
          <div ref={contentRef} className="support-content" role="tabpanel" id={"support-panel-" + activeTab} aria-labelledby={"support-tab-" + activeTab} tabIndex={0}>
            {activeTab === "help" ? <>
              <span className="support-badge"><Headphones size={15} aria-hidden="true" /> MTN SUPPORT CONTACT</span>
              <p className="support-intro">Need assistance with your Ghana Gameium subscription, games, account, or billing? Contact official MTN Ghana Customer Care through the channels below.</p>
              <div className="support-contacts">
                {contacts.map(([label, value, action, href, Icon]) => <div className="support-contact" key={label}>
                  <span className="support-contact-icon"><Icon size={23} aria-hidden="true" /></span>
                  <div className="support-contact-details"><span>{label}</span><strong>{value}</strong></div>
                  <a className="support-contact-action" href={href} {...(href.startsWith("https:") ? { target: "_blank", rel: "noopener noreferrer" } : {})}>{action}</a>
                </div>)}
                <div className="support-contact"><span className="support-contact-icon"><FaXTwitter size={23} aria-hidden="true" /></span><div className="support-contact-details"><span>Twitter / X</span><div className="support-social-links"><a href="https://x.com/MTNGhana" target="_blank" rel="noopener noreferrer">@MTNGhana</a><a href="https://x.com/AskMTNGhana" target="_blank" rel="noopener noreferrer">@AskMTNGhana</a></div></div></div>
              </div>
              <aside className="support-platform"><h3>GHANA GAMEIUM PLATFORM SUPPORT</h3><p>For platform-specific gaming feedback or inquiries, write to <a href="mailto:info@ekanatechnologies.com" style={{ color: "#ff547b", fontWeight: 800, textDecoration: "underline" }}>info@ekanatechnologies.com</a>.</p></aside>
            </> : <div className="support-policy-list">{policies[activeTab].map(([title, text, items], index) => <article className="support-policy-card" key={title}><span className="support-number">{index + 1}</span><div><h3>{title}</h3><p>{text}</p>{items && <ul>{items.map((item) => <li key={item}>{item}</li>)}</ul>}</div></article>)}</div>}
          </div>
        </div>
      </section>
    </div>
  );
}
export default Support;

